import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Stack, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

import { TopBarAnnouncementsButton } from '@/components/layout/topBar/components/announcementsButton/TopBarAnnouncementsButton.comp.tsx';
import { TopBarFeedbackButton } from '@/components/layout/topBar/components/feedbackButton/TopBarFeedbackButton.comp.tsx';
import { TopBarMailboxSyncIndicator } from '@/components/layout/topBar/components/mailboxSyncIndicator/TopBarMailboxSyncIndicator.comp.tsx';
import { TopBarItemsStyles, TopBarStyles } from '@/components/layout/topBar/TopBar.styles.ts';
import { useLogout } from '@/components/layout/topBar/util/useLogout.util.ts';
import { ViewDivider } from '@/components/ViewDivider.comp.tsx';
import { CONFIG } from '@/config/config.ts';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { Logo } from '../logo/Logo.comp';

export const TopBar: React.FC = () => {
  const { t } = useTranslationWithPrefix('topBar');
  const { logout } = useLogout();

  const handleLogout = async () => {
    await logout();
  };

  const { firstName } = useUserContext();

  return (
    <>
      <Stack direction="row" sx={TopBarStyles}>
        <Stack direction="row" spacing={4} sx={{ alignItems: 'center' }} useFlexGap>
          <Logo />
        </Stack>
        {!CONFIG.IS_PROD && <Box>{CONFIG.ENVIRONMENT}</Box>}
        <Stack direction="row" spacing={8} sx={TopBarItemsStyles}>
          <TopBarMailboxSyncIndicator />
          <TopBarAnnouncementsButton />
          <TopBarFeedbackButton />
          <Stack direction="row" spacing={1} sx={TopBarItemsStyles}>
            <Typography sx={{ color: themeColors.greyDarker, px: 1 }} variant="f16Regular">
              {t('welcome')},&nbsp;{firstName}!
            </Typography>
            <Divider
              flexItem
              orientation={'vertical'}
              sx={{ borderColor: themeColors.grey, height: 12 }}
            />
            <Tooltip title={t('tooltip.logout')}>
              <IconButton onClick={handleLogout}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </Stack>
      <ViewDivider />
    </>
  );
};
